import BaseEntity from '../BaseEntity';
import { FaceOutlineModel } from '../3d/boundingBox/faceOutlineModel';
import {
  EFaceDataBaseType,
  IBaseDataArcEdgeFace,
  IBaseDataCylinderFace,
  IBaseDataEdgeFace
} from '@/editor/data/face/face';
import { ENTITY_RENDER_ORDER } from '@/editor/constant/entity';

export default class FaceSelectedEntity extends BaseEntity {
  protected override _model3d: FaceOutlineModel;
  private _baseType: EFaceDataBaseType = EFaceDataBaseType.Edge;
  private _params: IBaseDataEdgeFace & IBaseDataCylinderFace & IBaseDataArcEdgeFace = {
    start: { x: 0, y: 0 },
    end: { x: 0, y: 0 },
    height: 0,
    offGround: 0,
    center: { x: 0, y: 0 },
    radius: 0,
    clockwise: false
  };
  private _created: boolean = false;

  constructor(color: number) {
    super();

    this._model3d = new FaceOutlineModel();
    this._model3d.setRenderOrder(ENTITY_RENDER_ORDER.renderOrderTemp);
    this._model3d.setColor(color);
  }

  get created() {
    return this._created;
  }

  override update(baseType: EFaceDataBaseType, params: IBaseDataEdgeFace | IBaseDataCylinderFace) {
    if (
      !(
        baseType === EFaceDataBaseType.Edge ||
        baseType === EFaceDataBaseType.Cylinder ||
        baseType === EFaceDataBaseType.ArcEdge
      )
    ) {
      return;
    }

    let needDestroyUpdate = !this._created || baseType !== this._baseType || false;
    this._baseType = baseType;

    switch (baseType) {
      case EFaceDataBaseType.Cylinder:
        needDestroyUpdate = this.compareCylinderParams(params as IBaseDataCylinderFace) || needDestroyUpdate;
        break;
      case EFaceDataBaseType.Edge:
        needDestroyUpdate = this.compareEdgeParams(params as IBaseDataEdgeFace) || needDestroyUpdate;
        break;
      case EFaceDataBaseType.ArcEdge:
        needDestroyUpdate = this.compareArcEdgeParams(params as IBaseDataArcEdgeFace) || needDestroyUpdate;
        break;
    }

    if (needDestroyUpdate) {
      // 过滤params 中undefined的key
      const filteredParams = Object.fromEntries(Object.entries(params).filter(([_, value]) => value !== undefined));
      this._params = { ...this._params, ...filteredParams };

      this.clear();
      switch (baseType) {
        case EFaceDataBaseType.Cylinder:
          this._model3d.createCylinderModel(this._params);
          break;
        case EFaceDataBaseType.Edge:
          this._model3d.createEdgeModel(this._params);
          break;
        case EFaceDataBaseType.ArcEdge:
          this._model3d.createArcEdgeModel(this._params);
          break;
      }
      this._created = true;
    }
  }

  private compareCylinderParams(params: IBaseDataCylinderFace) {
    if (
      this._params.center.x !== params.center.x ||
      this._params.center.y !== params.center.y ||
      this._params.radius !== params.radius ||
      this._params.offGround !== params.offGround ||
      this._params.height !== params.height
    ) {
      return true;
    }

    return false;
  }

  private compareEdgeParams(params: IBaseDataEdgeFace) {
    if (
      this._params.start.x !== params.start.x ||
      this._params.start.y !== params.start.y ||
      this._params.end.x !== params.end.x ||
      this._params.end.y !== params.end.y ||
      this._params.height !== params.height ||
      this._params.offGround !== params.offGround
    ) {
      return true;
    }

    return false;
  }

  private compareArcEdgeParams(params: IBaseDataArcEdgeFace) {
    if (
      this._params.start.x !== params.start.x ||
      this._params.start.y !== params.start.y ||
      this._params.end.x !== params.end.x ||
      this._params.end.y !== params.end.y ||
      this._params.height !== params.height ||
      this._params.offGround !== params.offGround ||
      this._params.center.x !== params.center.x ||
      this._params.center.y !== params.center.y ||
      this._params.clockwise !== params.clockwise
    ) {
      return true;
    }

    return false;
  }

  clear() {
    this._model3d.clearModel();
    this._created = false;
  }
}
